import ProjectDomains from './ProjectDomains'

export default ProjectDomains


// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectDomains/index.js